<template>
  <div>
    <el-card>
      <el-form
        :model="list"
        label-position="right"
        label-width="200px"
        ref="ruleForm"
        style="width: 90%; margin: 20px auto"
      >
        <el-row>
          <el-form-item label="标题">
            <el-input placeholder="请输入内容" v-model="list.title" clearable />
          </el-form-item>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="摘要" prop="content">
              <el-input
                type="textarea"
                :rows="4"
                placeholder="请输入内容"
                v-model="list.zhaiyao"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="类型" prop="type">
              <el-select
                clearable
                placeholder="请选择"
                size="small"
                v-model="list.type"
              >
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  v-for="item in type"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="时间" prop="createDate">
              <el-date-picker
                v-model="list.createDate"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="封面图" prop="coverImg" ref="coverImg">
              <el-upload
                class="avatar-uploader"
                :action="serverUrl"
                :headers="header"
                name="img"
                :auto-upload="true"
                :show-file-list="false"
                :on-success="upSuccess"
              >
                <img
                  v-if="list.coverImg"
                  :src="list.coverImg"
                  class="avatar"
                  style="width: 150px; height: auto"
                />

                <i
                  :class="
                    loadUpt
                      ? 'el-icon-loading'
                      : 'el-icon-plus avatar-uploader-icon'
                  "
                  style="margintop: 10px; font-size: 50px"
                  v-else
                ></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-button
            style="margin-left: 200px"
            type="primary"
            @click="submitAdd"
            >保存</el-button
          >
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import { baseURL } from "../../api/config";
export default {
  props: ["Changedata"],
  data() {
    return {
      loadUpt: false, //加载
      serverUrl: baseURL + "/file/uploadFile",
      header: {
        token: localStorage.getItem("key"),
      },
      list: [],
      type: [
        {
          value: 1,
          label: "直播图文",
        },
        {
          value: 0,
          label: "党建图文",
        },
      ],

      cascader: [],
      options: [],
      scTypeId: "",
      id: "",
    };
  },
  mounted() {
    this.list = this.Changedata;
  },
  methods: {
    //将中国标准时间转换为年月日格式  ----开始
    formatTen(num) {
      return num > 9 ? num + "" : "0" + num;
    },
    formatDate(date) {
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hour = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      return (
        year +
        "-" +
        this.formatTen(month) +
        "-" +
        this.formatTen(day) +
        " " +
        this.formatTen(hour) +
        ":" +
        this.formatTen(minute) +
        ":" +
        this.formatTen(second)
      );
    },
    upSuccess(file) {
      this.list.coverImg = file.entity;
    },
    handleChange(value) {
      this.scTypeId = value;
    },
    submitAdd() {
      var time = this.formatDate(new Date(this.list.createDate));
      this.postAxios("/broadcast/edit/main", {
        id: this.list.id,
        coverImg: this.list.coverImg,
        title: this.list.title,
        zhaiyao: this.list.zhaiyao,

        createDate: time,
        type: this.list.type,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
  watch: {
    Changedata(newVal, oldVal) {
      this.list = newVal;
    },
  },
};
</script>